export default "__VITE_ASSET__dgaCi7oS__"